<input #topAnchor matInput type="text" [readonly]="true" class="discoveryProcess_hiddenInput">
<div class="discoveryWizard_container">
    <div *ngIf="questionList.length > 0" class="discoveryWizard_currentQuestionContainer">
        <app-discovery-wizard-current-question-gap *ngIf="rediscoverProcessCurrentState != rediscoverProcessStateEnumInstance.PresentTailQuestion" class="discoveryWizard_currentQuestion" 
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]" 
            [allowTheUserToCancel]="true"
            (sendQuestionResponseEvent)="setUserResponse($event)"
            (cancelProcessEvent)="cancelProcess()">
        </app-discovery-wizard-current-question-gap>
        <app-discovery-wizard-current-question-tail *ngIf="rediscoverProcessCurrentState == rediscoverProcessStateEnumInstance.PresentTailQuestion" class="discoveryWizard_currentQuestion" 
            [ngClass]="{'is-mobile-view': isMobileView || isMediumResolutionView}"
            [isLoading] = isLoading
            [currentQuestion]="questionList[currentQuestionPos]" 
            (sendQuestionResponseEvent)="setUserResponse($event)"
            (cancelProcessEvent)="cancelProcess()">
        </app-discovery-wizard-current-question-tail>
    </div>
</div>